/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import { useCallback, useEffect, useState } from 'react';
import { Select } from 'tdesign-react';

import { FormArrayComponent } from '@/components/form/materials/Struct/formInputArray/form-array';

import styles from './index.module.less';

interface IProps {
  options: { label: string; value: string; disabled?: boolean }[];
  onChange: (value: { key: string; value: any[] }) => void;
  value: { key: string; value: any[] };
  disabled: boolean;
}

const ItemComp2: React.FC<IProps> = (props) => {
  const { options, value, disabled, onChange } = props;

  const [val, setVal] = useState<{ key: string; value: any[] }>({ key: '', value: [] });

  useEffect(() => {
    setVal(value);
  }, [value]);

  const handleChange1 = useCallback((val: any) => {
    setVal(pre => ({ ...pre, key: val }));
    onChange({ ...value, key: val });
  }, [value, onChange]);

  const handleChange2 = useCallback((val: any) => {
    setVal(pre => ({ ...pre, value: val }));
    onChange({ ...value, value: val });
  }, [value, onChange]);

  return (
    <div className={styles.root}>
      <div className={styles.wrapper1}>
        <Select options={options} value={val?.key} disabled={disabled} onChange={handleChange1} />
      </div>
      <div className={styles.wrapper2}>
        <FormArrayComponent fieldsConfig={[]} form={undefined} value={val.value} hasOperation={false} onChange={handleChange2} fieldname='value' config={undefined} getFieldDecorator={undefined} drag buttonSize='small' />
      </div>
    </div>
  );
};

export default ItemComp2;
